export default __webpack_public_path__ + "static/media/hrithik.6acb10e7.jpg";